import { Component, Input } from '@angular/core';
import { AuditData } from '../../../../../security-admin/models/field-audit';

@Component({
  selector: 'wre-field-history-card',
  templateUrl: './field-history-card.component.html',
  styleUrls: ['./field-history-card.component.sass']
})
export class FieldHistoryCardComponent {
  @Input() audit: AuditData;
  @Input() title;
  @Input() fieldType;
}

